// components
import { Table, Cell } from '../../../../../../../../common/Kendo/Table';
// data
import { columnConfig } from './drugTestingTable.config';

/**
 * DrugTestingTable component.
 *
 * Displays a table of drug testing data using the reusable Table component.
 * Data is sourced from SQL or test data if not provided.
 * Each column can display a badge in the header, replicating a US Government document layout.
 *
 * The table supports Excel export via a ref passed from the parent, allowing for
 * combined exports with other tables (e.g., AlcoholTestingTable).
 *
 * @see {@link https://concorde2k-my.sharepoint.com/:w:/g/personal/nlizzelco_civteam_com/EXnS_wpfYgNDgUYNXzbdYoYBWH_mrQQMB_CC6XO-Zn_YVw?e=j3DiDK | US Government Document Layout}
 * 
 * @param {Object} props
 * @param {Array} props.drugTestingData - Drug testing data to display in the table.
 * @param {Object} props.excelExportRef - Ref for Excel export, used for combined exports.
 * @param {boolean} [props.exportable=true] - Whether to show the export button.
 * @returns {JSX.Element} */
export const DrugTestingTable = ({
  drugTestingData,
  excelExportRef,
  exportable = true,
}) => {
  // handles export to Excel on button click
  const handleExport = () => {
    if (excelExportRef.current) {
      console.info('Drug Testing export started!');
    } else {
      console.warn('ExcelExport ref is not ready yet.');
    }
  };

  // integrates custom header cells from config
  const headerCells = columnConfig.map((col) => {
    if (col.badge) {
      return {
        component: Cell.TopCenterBadge,
        props: {
          title: col.title,
          badge: col.badge,
          badgeTheme: 'inherit'
        }
      };
    }
    // fallback renders title in a fragment
    return {
      component: ({ title }) => <>{title}</>,
      props: { title: col.title }
    };
  });

  // builds table
  return (
    <>
      <Table
        data={drugTestingData}
        pageable={false}
        columnConfig={columnConfig}
        headerCells={headerCells}
        exportable={exportable}
        onExportExcel={handleExport}
        excelExportRef={excelExportRef}
        pageSize={10}
        pageSizes={[5, 10, 20]}
        tableHeight='450px'
        title="Drug Testing"
      />
    </>
  );
}